import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilderTypeSafe, FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { AutoComplete } from 'primeng/autocomplete';
import { Subscription } from 'rxjs';
import { EotpremnicaFormService } from '../../otpremnice/eotpremnica-form.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { IStrankaOtpremniceDto, RacuniClient, TipOtpremnice } from '@kodit/core/data-api';
import { RacunService } from '@kodit/core/services';

export interface IRequest {
  searchValue: string;
}

@Component({
  selector: 'kodit-stranka-eotpremnice-autocomplete',
  templateUrl: './stranka-eotpremnice-autocomplete.component.html',
  styleUrls: ['./stranka-eotpremnice-autocomplete.component.scss']
})
export class StrankaEotpremniceAutocompleteComponent implements OnInit, OnDestroy {

   /** Subs */
  private _searchSub: Subscription = new Subscription();
  private _vezaniRacunSub: Subscription = new Subscription();

  /** Props */
  formGroup: FormGroupTypeSafe<IRequest>;
  pravnaLicaSuggestions: IStrankaOtpremniceDto[] = [];
  ctrlPlaceholder: string = 'Matični broj, PIB ili naziv...';

  @ViewChild('autocompleteRef') autocompleteRef: AutoComplete;

  /** I/O */
  @Input() parentCtrl: any = 'body';
  @Input() mustSelect: boolean = false;
  @Input() ctrlDisabled: boolean = false;
  @Input() jePrevoznik: boolean = false;
  @Output() onNazivChange = new EventEmitter<string>();
  @Output() onPravnoLiceChange = new EventEmitter<IStrankaOtpremniceDto>();
  @Output() onPravnoLiceClear = new EventEmitter<void>();

  constructor(
    private _fb: FormBuilderTypeSafe,
    private _client: RacuniClient,
    private _otpremniceService: EotpremnicaFormService,
    private _route: ActivatedRoute,
    private _racunService: RacunService,
  ) {}

  ngOnInit(): void {
    this.formGroup = this._fb.group<IRequest>({
      searchValue: new FormControl(''),
    });

    this.ctrlDisabled = this._otpremniceService.getOtpremnicaFormObject?.controls.tipOtpremnice.value === TipOtpremnice.INTERNA;
  }

  /**FAKTURE
   * Sluzi da nam da predlozena pravna lica na osnovu pretrage
   * Ukoliko forma nije tacna, nece se ni raditi pretraga
   */
  searchPravnoLice(event: any) {
    if (this.formGroup.value.searchValue.length < 1) {
      this.pravnaLicaSuggestions = [];
      return;
    }
    this._searchSub.unsubscribe();
    this._searchSub = this._client
      .searchStrankaRacuna(this.formGroup.value.searchValue)
      .subscribe((result) => {
        if (result.succeeded) {
          this.pravnaLicaSuggestions = [...result.data.strankaRacunaDtoList];
        } else {
          this.pravnaLicaSuggestions = [];
        }
      });
  }

  ngAfterViewInit() {
    // this._racunService.getPerformSearchFizickogLica.subscribe((res) => {
    //   if (res) {
    //     this.formGroup.controls.searchValue.patchValue(res);
    //     this.autocompleteRef.handleDropdownClick(null);
    //   }
    // });
  }

  /**
   * Pri odabiru pravnog lica iz liste ponudenih setuje model u servisu
   * @param value odabrano pravno lice
   */
  selectionChanged(value: IStrankaOtpremniceDto) {
    if (this.onPravnoLiceChange) {
      this.onPravnoLiceChange.emit(value);
      this.formGroup.controls.searchValue.reset('');
      //this._racunService.setShowFizickoLiceCreate = null;
    }
  }

  nazivChanged(event: any) {
    if (this.onNazivChange && event.target?.value) {
      this.onNazivChange.emit(event.target.value);
    }
  }

  onClear() {
    this.formGroup.reset();
    if (this.onPravnoLiceClear) {
      this.onPravnoLiceClear.emit();
    }
  }

  ngOnDestroy(): void {
    this._searchSub.unsubscribe();
    this._vezaniRacunSub.unsubscribe();
  }

}
